import { useState } from "react";


const CategoriaFiltro = (props) => {

    const { key, history, opcion, tipo, claseIcono, filtros: item, filtrosSeleccionados, setFiltrosSeleccionados } = props;
    const [mostrarFiltros, setMostrarFiltros] = useState(false);

    const llaves = Object.keys(item);
    const titulo = item[llaves[0]];
    const filtros = item[llaves[1]];

    const buscarFiltro = (id) => {
        const obtenido = filtrosSeleccionados.find(fs => fs.id == id);
        return obtenido ? true : false;
    }

    const handleChange = (e, id, tipo, nombre) => {

        if (buscarFiltro(id)) {
            //En caso de que ya haya estado como filtros
            const aux = filtrosSeleccionados.filter((fs) => fs.id != id)
            setFiltrosSeleccionados(aux)
            if (aux.length == 0) {
                if (opcion == "Marcas") {
                    history.push("./Catalogo/Categoria/-1/Todos/1")
                }
            }
        } else {
            //En caso de que el filtro no se haya seleccionado
            setFiltrosSeleccionados([...filtrosSeleccionados, { id: id, tipo: tipo, nombre: nombre }]);
        }
    }
    return (
        <div className="contenedor-filtro">
            <div className="contenedor-filtro-header">
                <h3>{titulo}</h3>
                <div
                    className="icono-caret"
                    onClick={
                        () => {
                            setMostrarFiltros(!mostrarFiltros);
                        }
                    }
                    style={
                        {
                            transform: `rotate(${mostrarFiltros ? 0 : -0.5}turn)`
                        }
                    }
                >
                    <i className={claseIcono} aria-hidden="true"></i>
                </div>
            </div>

            <div
                className="contenedor-filtro-body"
                style={
                    {
                        height: mostrarFiltros ? "auto" : "0px",
                        transition: "1s"
                    }
                }
            >
                {
                    filtros.map(
                        (f, i) => {
                            // const keys = f.Object.keys(item);
                            return (
                                <div
                                    key={i + tipo + f.nombre}
                                    className="contenedor-filtro-body-item"
                                >
                                    <input
                                        type="checkbox"
                                        id={i + tipo + f.nombre}
                                        value={f.id}
                                        checked={filtrosSeleccionados ? buscarFiltro(f.id) : false}
                                        onChange={
                                            (e) => {
                                                handleChange(e, f.id, tipo, f.nombre);
                                            }
                                        }
                                    />
                                    <label
                                        htmlFor={i + tipo + f.nombre}
                                    >
                                        <span>{f.nombre}</span>
                                    </label><br />

                                </div>
                            );
                        }
                    )
                }
            </div>

        </div>
    )
}

export default CategoriaFiltro;
